const industryList = require('@/utils/industryList')
const icons = {
  country: '/static/country.png',
  dealType: '/static/dealType.png',
  price: '/static/price.png',
  resultType: '/static/resultType.png',
  time: '/static/time.png',
  fbuzti: '/static/fbuzti.png',
  cpfl: '/static/cpfl.png'
}

const publicOptions = {
  isMore: false,
  hasMore: false,
  moreTitle: '展开'
}

const filterOptions = [
  {
    ...publicOptions,
    name: '产业分类',
    prop: 'industrialType',
    icon: icons.cpfl,
    tagList: industryList.industryLists
  },
  {
    ...publicOptions,
    name: '需求类型',
    prop: 'demandsType',
    icon: icons.resultType,
    tagList: [
      { name: '技术难题', value: '1', key: 'demandsType1' },
      { name: '产品需求', value: '2', key: 'demandsType2' },
      { name: '服务需求', value: '3', key: 'demandsType3' },
      { name: '其他需求', value: '4', key: 'demandsType4' }
      // { name: '不限', value: '', key: 'demandsType' }
    ]
  },
  {
    ...publicOptions,
    name: '发布时间',
    icon: icons.time,
    prop: 'searchValue',
    tagList: [
      { name: '今天', value: '1', key: 'day1' },
      { name: '三天内', value: '2', key: 'day2' },
      { name: '一周内', value: '3', key: 'day3' },
      { name: '一个月内', value: '4', key: 'day4' },
      { name: '三个月内', value: '5', key: 'day5' },
      { name: '一年内', value: '6', key: 'day6' }
      // { name: '不限', value: '0', key: 'day0' }
    ]
  },
  {
    ...publicOptions,
    name: '发布主体',
    prop: 'companyType',
    icon: icons.fbuzti,
    tagList: [
      { name: '企业', value: '1', key: '1' },
      { name: '个人', value: '2', key: '2' },
      { name: '其他', value: '3', key: '3' }
      // { name: '不限', value: '', key: '_infinity' }
    ]
  }
]

module.exports = {
  filterOptions
}
